module.exports = __webpack_public_path__ + "static/media/dark1.6ed75c55.JPG";